'use client';

import type { MessageKeys } from 'next-intl';
import type { Messages } from '@/global';
import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';

export const FileUploaderLabel = ({
  fileUploaderChooseFile,
  idValue,
  inputLabel,
}: {
  fileUploaderChooseFile: MessageKeys<
    Messages,
    'PICTURE_UPLOADER.CHOOSE_PICTURE' | 'FILE_UPLOADER.CHOOSE_FILE'
  >;
  idValue: string;
  inputLabel: string;
}) => {
  const t = useTranslations();

  return (
    <label
      className="vp-button vp-button--secondary"
      htmlFor={`uploader${idValue}`}
    >
      <span
        className="vp-button__label"
        data-part="label"
      >
        <div data-part="start-slot" data-testid="icon-attachment">
          <VpIcon name="attachment" />
        </div>
        <span className="control-upload__label">
          {' '}
          {inputLabel || t(fileUploaderChooseFile)}
          {' '}
        </span>
      </span>
    </label>
  );
};
